export default {
  USERS(state, { data, total, page, pageSize }) {
    state.users = { data, total, page, pageSize } || {}
  },
  RESET_USERS(state, payload) {
    state.users = {}
  },
  DELETE_USER(state, payload) {
    state.users.data = state.users.data.filter(u => u.email !== payload)
  },
  UPDATE_USER(state, payload) {
    state.users.data.splice(payload.index, 1, payload.item)
  },
  SET_NEW_USER(state, payload) {
    state.newUser = payload || {}
  },
  RESET_NEW_USER(state, payload) {
    state.newUser = {}
  },
  TOAST_USER (state, payload) {
    state.toast = { title: 'User', message: payload }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/users/mutations.js